const SELECTORS = {
  drawer: '[data-locale-drawer]',
  overlay: '[data-locale-drawer-overlay]',
  openTrigger: '[data-locale-drawer-open]',
  close: '[data-locale-drawer-close]',
  list: '[data-locale-drawer-list]',
  countryBtn: '[data-select-country]',
  multiCountry: '[data-country-multi]',
  expandToggle: '[data-expand-toggle]',
  langOption: '[data-select-locale]',
  countryInput: '#drawer-country-input',
  localeInput: '#drawer-locale-input',
  form: '#locale-drawer-form',
  search: '[data-locale-search]',
  showMore: '[data-show-more]',
  item: '.virea-locale-item',
  empty: '[data-locale-empty]',
};

let drawer;
let overlay;
let form;
let countryInput;
let localeInput;
let list;
let searchInput;
let showMoreBtn;
let emptyState;
let focusableEls = [];
let lastFocusedEl = null;

function init() {
  drawer = document.querySelector(SELECTORS.drawer);
  overlay = document.querySelector(SELECTORS.overlay);

  if (!drawer || !overlay) return;

  form = document.querySelector(SELECTORS.form);
  countryInput = document.querySelector(SELECTORS.countryInput);
  localeInput = document.querySelector(SELECTORS.localeInput);
  list = drawer.querySelector(SELECTORS.list);
  searchInput = drawer.querySelector(SELECTORS.search);
  showMoreBtn = drawer.querySelector(SELECTORS.showMore);
  emptyState = drawer.querySelector(SELECTORS.empty);

  if (showMoreBtn) {
    showMoreBtn.addEventListener('click', toggleShowMore);
  }

  if (searchInput) {
    searchInput.addEventListener('input', handleSearch);
  }

  document.querySelectorAll(SELECTORS.openTrigger).forEach((btn) => {
    btn.addEventListener('click', openDrawer);
  });

  drawer.querySelector(SELECTORS.close).addEventListener('click', closeDrawer);

  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  drawer.querySelectorAll(SELECTORS.countryBtn).forEach((btn) => {
    btn.addEventListener('click', function () {
      const code = this.getAttribute('data-select-country');
      submitLocale(code, null);
    });
  });

  drawer.querySelectorAll(SELECTORS.expandToggle).forEach((btn) => {
    btn.addEventListener('click', function () {
      const wrapper = this.closest(SELECTORS.multiCountry);
      toggleExpand(wrapper);
    });
  });

  drawer.querySelectorAll(SELECTORS.langOption).forEach((btn) => {
    btn.addEventListener('click', function () {
      const countryCode = this.getAttribute('data-country');
      const langCode = this.getAttribute('data-lang');
      submitLocale(countryCode, langCode);
    });
  });
}

function openDrawer() {
  lastFocusedEl = document.activeElement;
  drawer.classList.add('is-open');
  overlay.classList.add('is-open');
  document.body.classList.add('locale-drawer-open');

  const closeBtn = drawer.querySelector(SELECTORS.close);
  if (closeBtn) closeBtn.focus();

  focusableEls = Array.from(
    drawer.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
  );

  document.addEventListener('keydown', trapFocus);
}

function closeDrawer() {
  drawer.classList.remove('is-open');
  overlay.classList.remove('is-open');
  document.body.classList.remove('locale-drawer-open');

  document.removeEventListener('keydown', trapFocus);

  if (lastFocusedEl) lastFocusedEl.focus();
}

function toggleExpand(wrapper) {
  const isExpanded = wrapper.classList.contains('is-expanded');
  const toggle = wrapper.querySelector(SELECTORS.expandToggle);

  drawer.querySelectorAll(`${SELECTORS.multiCountry}.is-expanded`).forEach((el) => {
    if (el !== wrapper) {
      el.classList.remove('is-expanded');
      el.querySelector(SELECTORS.expandToggle).setAttribute('aria-expanded', 'false');
    }
  });

  if (isExpanded) {
    wrapper.classList.remove('is-expanded');
    toggle.setAttribute('aria-expanded', 'false');
  } else {
    wrapper.classList.add('is-expanded');
    toggle.setAttribute('aria-expanded', 'true');
  }
}

function submitLocale(countryCode, langCode) {
  if (!form || !countryInput) return;

  countryInput.value = countryCode;

  if (langCode && localeInput) {
    localeInput.value = langCode;
  }

  try {
    localStorage.setItem('virea_geo_applied', '1');
  } catch {}

  form.submit();
}

function toggleShowMore() {
  const expanded = list.classList.toggle('is-expanded');
  showMoreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
}

function handleSearch(e) {
  const q = e.target.value.trim().toLowerCase();
  const items = list.querySelectorAll(SELECTORS.item);
  let visibleCount = 0;

  if (q === '') {
    list.classList.remove('is-searching');
    items.forEach((el) => {
      el.classList.remove('is-filtered-out');
    });
    if (emptyState) emptyState.hidden = true;
    return;
  }

  list.classList.add('is-searching');

  items.forEach((el) => {
    const name = el.getAttribute('data-search-name') || '';
    const iso = (el.getAttribute('data-iso') || '').toLowerCase();
    const match = name.includes(q) || iso.includes(q);
    if (match) {
      el.classList.remove('is-filtered-out');
      visibleCount++;
    } else {
      el.classList.add('is-filtered-out');
    }
  });

  if (emptyState) emptyState.hidden = visibleCount > 0;
}

function trapFocus(e) {
  if (e.key !== 'Tab' || focusableEls.length === 0) return;

  const first = focusableEls[0];
  const last = focusableEls[focusableEls.length - 1];

  if (e.shiftKey) {
    if (document.activeElement === first) {
      e.preventDefault();
      last.focus();
    }
  } else if (document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
